module.exports = __webpack_public_path__ + "static/media/icon-money-green.f38edb7e.svg";